import { DataGridPro } from "@mui/x-data-grid-pro";
import { columns, getRowId } from "./utils";
import { useMemo } from "react";
import { tableStyles } from "./utils";
import { Stack, Typography } from "@mui/material";
import { useBoundStore } from "useStore";

export default function CampaignManagerTable({ data, rowCount }) {
  const campaignManagerSelectionModel = useBoundStore(
    (state) => state.campaignManagerSelectionModel,
  );
  const setCampaignManagerSelectionModel = useBoundStore(
    (state) => state.setCampaignManagerSelectionModel,
  );
  const toggleCmEditedRow = useBoundStore((state) => state.toggleCmEditedRow);
  const paginationModel = useBoundStore(
    (state) => state.campaignManagerPaginationModel,
  );
  const setPaginationModel = useBoundStore(
    (state) => state.setCampaignManagerPaginationModel,
  );
  const selectedColumns = useBoundStore(
    (state) => state.campaignManagerColumns,
  );
  const gridSx = useMemo(
    () => ({
      ...tableStyles,
      "& .row-expanded .MuiDataGrid-cell": { backgroundColor: "#E4F3FA" },
      "& .row-child .MuiDataGrid-cell": { backgroundColor: "#FBFBFB" },
      "& .MuiDataGrid-row.Mui-selected": {
        backgroundColor: "rgba(0, 40, 120, 0.08) !important",
      },
      "& .MuiDataGrid-row.Mui-selected:hover": {
        backgroundColor: "rgba(0, 40, 120, 0.12) !important",
      },
      "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell": {
        backgroundColor: "transparent !important",
      },
      "& .MuiDataGrid-row:hover": {
        backgroundColor: "rgba(0, 40, 120, 0.08) !important",
      },
      "& .MuiDataGrid-row:hover .MuiDataGrid-cell": {
        backgroundColor: "transparent !important",
      },
      "& .MuiDataGrid-scrollbar": { pointerEvents: "auto" },
      "& .MuiDataGrid-scrollbar--horizontal": { outline: "none" },
      '& [tabindex="-1"]': { outline: "none !important" },
    }),
    [],
  );

  const rows = data ?? [];

  const handleRowSelectionModelChange = (newSelection) => {
    const added = newSelection.filter(
      (id) => !campaignManagerSelectionModel.includes(id),
    );
    const removed = campaignManagerSelectionModel.filter(
      (id) => !newSelection.includes(id),
    );
    added.forEach((id) => {
      const row = rows.find((r) => getRowId(r) === id);
      if (row) toggleCmEditedRow(id, row);
    });
    removed.forEach((id) => {
      toggleCmEditedRow(id, null);
    });
    setCampaignManagerSelectionModel(newSelection);
  };

  return (
    <>
      <Stack direction="column" spacing={2}>
        <Stack direction="column" spacing={0.5}>
          <Typography
            sx={{
              fontWeight: 600,
              color: "#000000DE",
              fontSize: "24px",
              lineHeight: "24px",
            }}
          >
            Campañas
          </Typography>
          <Typography
            sx={{ fontSize: "14px", color: "#000000DE", lineHeight: "24px" }}
          >
            Selecciona una campaña para ver sus anuncios
          </Typography>
        </Stack>
        <DataGridPro
          rows={rows}
          columns={columns}
          getRowId={getRowId}
          sx={gridSx}
          rowHeight={72}
          pagination
          paginationMode="server"
          rowCount={rowCount ?? rows.length}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[10, 25, 50]}
          columnVisibilityModel={selectedColumns}
          disableColumnMenu
          rowSelectionModel={campaignManagerSelectionModel}
          onRowSelectionModelChange={handleRowSelectionModelChange}
          disableRowSelectionOnClick
          disableColumnReorder
          processRowUpdate={(row) => row}
        />
      </Stack>
    </>
  );
}
